import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface PaymentRefreshContextType {
  refreshTrigger: number;
  triggerRefresh: () => void;
  isRefreshing: boolean;
  setRefreshing: (value: boolean) => void;
}

const PaymentRefreshContext = createContext<PaymentRefreshContextType | undefined>(undefined);

interface PaymentRefreshProviderProps {
  children: ReactNode;
}

export const PaymentRefreshProvider: React.FC<PaymentRefreshProviderProps> = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const triggerRefresh = useCallback(() => {
    console.log('[PAYMENT_REFRESH] Triggering global payment refresh');
    setRefreshTrigger(prev => prev + 1);
  }, []);

  const setRefreshing = useCallback((value: boolean) => {
    setIsRefreshing(value);
  }, []);

  const value = {
    refreshTrigger,
    triggerRefresh,
    isRefreshing,
    setRefreshing
  };

  return (
    <PaymentRefreshContext.Provider value={value}>
      {children}
    </PaymentRefreshContext.Provider>
  );
};

export const usePaymentRefresh = () => {
  const context = useContext(PaymentRefreshContext);
  if (context === undefined) {
    throw new Error('usePaymentRefresh must be used within a PaymentRefreshProvider');
  }
  return context;
};